import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { quotationQueryOptions } from '../../../../features/sales/queries'

export const Route = createFileRoute('/_app/quotations/$quotationId')({
  staticData: { crumb: 'quotation' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(quotationQueryOptions(params.quotationId)),
  component: Outlet,
})
